import { garageListQuerySchema, type GarageView } from '@chukua/common';
import { useEffect, useState } from 'react';
import { listGarages } from '../../garages/garages.api';

/** Every active garage, fetched whole: the directory is a handful of workshops, so the picker opens with its choices. Null until loaded. */
export function useGarageOptions(): GarageView[] | null {
  const [garages, setGarages] = useState<GarageView[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    listGarages(garageListQuerySchema.parse({ pageSize: 100, status: ['active'] }))
      .then((page) => !cancelled && setGarages(page.items))
      .catch(() => !cancelled && setGarages([]));
    return () => {
      cancelled = true;
    };
  }, []);

  return garages;
}
